
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-enhancer",
      function () {
        return require("private-next-pages/video-enhancer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-enhancer"])
      });
    }
  